import React from 'react';
import { Input } from 'structure/staking/components/form/Input';
import { FormControl } from 'structure/staking/components/form/FormControl';
import { InputProps } from 'baseui/input';
import { getTokenIconUrl } from 'utils/url';
import { TokenImage } from 'components/TokenImage';
import { Controller, UseControllerProps } from 'react-hook-form';

type InputTokenAmountProps = Omit<InputProps, 'error' | 'min' | 'max'> & {
  label?: React.ReactNode;
  tokenSymbol: string;
  endEnhancer?: React.ReactNode;
  error?: string | undefined;
  min?: string | number;
  max?: string | number;
};

export const InputTokenAmount = React.forwardRef(function (
  props: InputTokenAmountProps & UseControllerProps,
  ref: React.ForwardedRef<HTMLInputElement>
) {
  const {
    control,
    label,
    tokenSymbol,
    min,
    max,
    error,
    endEnhancer = null,
    ...rest
  } = props;

  return (
    <FormControl label={label} error={error}>
      <Controller
        {...rest}
        control={control}
        render={({ field }) => (
          <Input
            {...rest}
            onChange={(e) => {
              let value = e.currentTarget.value.replace(',', '.');

              // 01 -> 1 - remove leading zero
              if (/^0\d/.test(value)) {
                value = parseFloat(value).toString();
              }

              field.onChange(value);
            }}
            value={field.value}
            type='text'
            step='any'
            inputRef={ref}
            startEnhancer={
              <div className='flex items-center gap-2'>
                <TokenImage
                  symbol={tokenSymbol}
                  height={24}
                  width={24}
                  src={getTokenIconUrl(tokenSymbol)}
                  alt={tokenSymbol}
                />
              </div>
            }
            endEnhancer={endEnhancer}
          />
        )}
      />
    </FormControl>
  );
});
